import { useAuth } from "@/providers/auth-context"
import { AxiosError } from "axios"
import { AlertCircle } from "lucide-react"
import { useEffect } from "react"

type ApiErroPageProps = {
  error: AxiosError<ApiError>
}

const ApiErroPage = ({ error }: ApiErroPageProps) => {
  const { logout } = useAuth()

  useEffect(() => {
    setTimeout(() => {
      logout()
    }, 10000)
  }, [logout])

  return (
    <main className="flex min-h-screen items-center justify-center bg-background">
      <article className="w-full max-w-md rounded-lg bg-card px-6 py-8 text-center shadow-lg">
        <AlertCircle className="mx-auto size-12 text-destructive" />
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-foreground">
          Ops! Algo deu errado
        </h1>
        <p className="mt-2 text-base text-muted-foreground">
          Pedimos desculpas pelo inconveniente. Ocorreu um
          erro com suas permissões. Você será redirecionado
          para a página de login.
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          Se o problema persistir, entre em contato com
          nossa equipe de suporte.
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          {error.response?.data.message}
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          {error.response?.data.requestId}
        </p>
      </article>
    </main>
  )
}

export default ApiErroPage
